import { useState } from 'react';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { TabsOptionsType } from '../../types';

export default function useTabSelections() {
  const [activeTab, setActiveTab] = useState<TabsOptionsType>('routingRules');

  const { userProfile, companyName } = useGetGeneralAppData();

  function handleChangeActiveTab(selectedTab: TabsOptionsType) {
    setActiveTab(selectedTab);
  }

  return {
    userProfile,
    activeTab,
    handleChangeActiveTab,
    companyName,
  };
}
